import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M9 8l1 8l2 -5l2 5l1 -8","key":"svg-0"}]]

const IconLetterWSmall = createReactComponent('outline', 'letter-w-small', 'LetterWSmall', __iconNode);

export default IconLetterWSmall;